import { _axios as request } from '@/plugins/axios'

const actions = {
  login(_, data) {
    return new Promise((resolve, reject) => {
      request({
          url: '/user/webLogin',
          method: 'post',
          data: data
        })
        .then((response) => {
          sessionStorage.setItem("token", response.headers.token);
          sessionStorage.setItem("profile", JSON.stringify(response.data.data));
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  logout() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("profile");
    // location.replace("/");
  },
  changeNewPassword(_,data){
    return new Promise((resolve, reject) => {
      request({
        url: '/user/modifyPassword',
        method: 'post',
        params: data,
      })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
    });
  }
}

export default {
  namespaced: true,
  actions,
};
